import { makeAutoObservable } from 'mobx';
import { DEFAULT_PAGE_SIZE } from '../config/config';
import OrderApi from '../services/OrderApi';
import { PaginationParams } from '../types';
import { message } from 'antd';
import orderBonusApi from '../services/OrderBonusApi';


class OrderBonusStore {
    loading: boolean = false;
    orderList: any = [];
    orderCustomerList: any = [];
    sort: string = '';
    order: any = [];
    totalPages: number = 0;
    page: number = 0;
    totalElements: number = 0;
    size: number = DEFAULT_PAGE_SIZE;
    defaultparams = {
        size: DEFAULT_PAGE_SIZE,
        page: 0,
        sort: 'created,desc',
    }

    constructor() {
        makeAutoObservable(this);
    }

    async getList(params: PaginationParams) {
        this.loading = true;
        const response = await orderBonusApi.getList(params);
        if (!response.error) {
            this.orderList = response.data.content;
            this.totalPages = response.data.totalPages;
            this.page = response.data.number;
            this.totalElements = response.data.totalElements;
            this.size = response.data.size;
        } else {
            message.error(`Erro ao buscar Listagem`);
        }
        this.loading = false;
        return response;
    }


    async updateStatusBonus(uuid: any, params: any) {
        this.loading = true;
        const response = await orderBonusApi.updateStatusBonus(uuid, params);
        
        if (response?.error) {
            message.error(`Erro ao atualizar`);
        } 
        this.loading = false;
        return response;
    }
}

const orderBonusStore = new OrderBonusStore();
export default orderBonusStore;